import React, {useEffect} from 'react';
import './App.css';
import {Route, Switch, BrowserRouter as Router} from 'react-router-dom';
import {connect} from 'react-redux';
import localForage from 'localforage';
import withAuth from './components/hoc/withAuth';
import NotificationsContainer from './components/notfications/NotificationsContainer';

// Assets
import './fonts/fonts.css';

// pages
import ContentWrapper from './pages/ContentWrapper';
import Customers from './pages/Customers';
import CustomerProfile from './pages/CustomerProfile';
import FulfillmentCustomers from './pages/FulfillmentCustomers';
import FulfillmentContracts from './pages/FulfillmentContracts';
import DashboardLogin from './pages/DashboardLogin';
import Support from './pages/Support';
import CustomerDevices from './pages/CustomerDevices';
import CustomerContracts from './pages/CustomerContracts';
import NotFound from './pages/NotFound';
import FulfillmentPolicies from './pages/FulfillmentPolicies';
import {roles} from './utils/auth';
import Default from './pages/DefaultPage';
import {findUser, patchUser} from './redux/actions/userActions';
import {getUser} from './api/network/authService';
import AlertsPage from './pages/AlertsPage';

//TODO pull company data from business customer login.
const companyData = {
    id: '3b2195ec-d3cf-4106-f77e-08d746adadff',
    name: 'Smart Mobile Solutions',
    address: '12 Ruthven Rd, Kingston',
    dateIncorporated: '2009-10-10T00:00:00'
};

localForage.config({
    driver: localForage.INDEXEDDB, // Force WebSQL; same as using setDriver()
    name: 'dashboard',
    version: 1.0,
    storeName: 'keyvaluepairs', // Should be alphanumeric, with underscores.
    description: 'some description'
});

localForage.ready().then(() => {
    // This code runs once localforage
    // has fully initialized the selected driver.
    console.log('IndexedDB: ', localForage.driver()); // LocalStorage
}).catch(e => {
    // One of the cases that `ready()` rejects,
    // is when no usable storage driver is found
});

/**
 *
 * @param auth
 * @param findUser
 * @param patchUser
 * @returns {JSX.Element}
 * @constructor
 */
function App({auth, findUser, patchUser}) {
    useEffect(() => {
        findUser(auth.id, auth.role);

        const getUserInfo = async (id, token) => {
            const userInfo = await getUser(id, token);
            const {firstName, lastName, email, userName} = userInfo;
            patchUser({firstName, lastName, email, userName});

            console.log('user info', userInfo);
        };
        getUserInfo(auth.id, auth.token)
            .catch(error => {
                console.error('failed to get user info', error);
            });
    }, []);

    // hello??
    console.log('');

    // Roles Auth configurations
    const Admins = withAuth([roles.ADMIN]);
    const FulfillmentAuth = withAuth([roles.GK, roles.ADMIN]);
    const CustomerAuth = withAuth([roles.CUSTOMER_REP]);
    const CompanyAuth = withAuth([roles.BAM]);
    const SmsAuth = withAuth([roles.SMS]);
    const BasicAuth = withAuth([]);

    return (
        <div className="App">
            <Router basename={process.env.REACT_APP_BASE_PATH}>
                <main>
                    <Switch>
                        <Route path="/login" exact={true} component={BasicAuth(DashboardLogin)}/>
                        <Route path="/404" exact={true} component={NotFound}/>
                        <Route path="/*">
                            <Switch>
                                <ContentWrapper>
                                    <Route path="/" exact={true} component={CompanyAuth(Default)}/>

                                    {/*Company*/}
                                    <Route path="/company/customers" exact={true} component={CompanyAuth(Customers)}/>
                                    <Route path="/company/customers/:companySlug/:customerSlug" exact={true} component={CompanyAuth(CustomerProfile)}/>

                                    {/*Customer*/}
                                    <Route path="/customers/contracts" exact={true} component={CompanyAuth(CustomerContracts)}/>
                                    {/*<Route path="/customers/:companySlug/:customerSlug" exact={true} component={CustomerAuth(CustomerProfile)}/>*/}
                                    {/*<Route path={"/customers/:slug"} exact={true} component={CompanyAuth(CustomerProfile)}/>*/}
                                    <Route path="/customers/support" exact={true} component={CompanyAuth(Support)}/>
                                    <Route path="/customers/devices" exact={true} component={CompanyAuth(CustomerDevices)}/>

                                    <Route path="/Alerts" exact={true} component={BasicAuth(AlertsPage)}/>

                                    {/*Fulfillment*/}
                                    <Route path="/fulfillment/customers" exact={true} component={FulfillmentAuth(FulfillmentCustomers)}/>
                                    <Route path="/fulfillment/customers/:companySlug/:customerSlug" exact={true} component={FulfillmentAuth(CustomerProfile)}/>
                                    <Route path="/fulfillment/contracts" exact={true} component={FulfillmentAuth(FulfillmentContracts)}/>
                                    <Route path="/fulfillment/policies" exact={true} component={FulfillmentAuth(FulfillmentPolicies)}/>
                                    <Route path="/fulfillment/support" exact={true} component={FulfillmentAuth(Support)}/>
                                    <Route path="/fulfillment/support" exact={true} component={FulfillmentAuth(Support)}/>

                                    <Route path="/*" exact={true} component={NotFound}/>
                                </ContentWrapper>
                            </Switch>
                        </Route>
                    </Switch>
                </main>
                <NotificationsContainer/>
            </Router>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        auth: state.auth,
        // user: state.user
    };
}

const mapDispatcherToProp = {
    findUser,
    patchUser,
};

export default connect(mapStateToProps, mapDispatcherToProp)(App);
